import { FeaturedEvents } from 'components/FeaturedEvents/FeaturedEvents';
import './SearchResultsNoResults.scss';

export const SearchResultsNoResults = () => (
  <div className="no-search-results">
    <div className="container">
      <h2 className="no-search-results__heading h3">
        Sorry! We couldn't find any events that match your query.
      </h2>
      <h3 className="h4 color-grey">
        Try using a different keyword and/or try adding some filters.
      </h3>
      <hr />
      <p className="no-search-results__footer h4">
        If it helps, here are some other events we think you might be interested
        in...
      </p>
    </div>
    <FeaturedEvents sectionTitle="We think you'll love" />
  </div>
);
